import { Button, ButtonProps, ComponentWithAs, IconProps, Text, defineStyle } from '@chakra-ui/react';
import React from 'react';

export type ActionButtonProps = {
  Icon: ComponentWithAs<'svg', IconProps>;
  text: string;
  handleClick: () => void;
};

const actionButtonStyles = defineStyle({
  w: '100%',
  backgroundColor: 'bgColor.100',
  variant: 'outline',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  border: '1px solid',
  borderColor: 'borderGrey.100',
  borderRadius: '12px',
  py: '8px',
  h: 'auto',
  gap: '5px',
  transition: 'background, border',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'ease-in-out',
  _hover: { borderColor: 'green.100', backgroundColor: 'greenA.900' },
}) as ButtonProps;

export const ActionButton = React.memo(({ Icon, text, handleClick }: ActionButtonProps) => {
  return (
    <Button onClick={handleClick} {...actionButtonStyles}>
      <Icon />
      <Text fontSize={{ base: '12px', sm: '14px' }} fontWeight={400}>
        {text}
      </Text>
    </Button>
  );
});
